import React, { Fragment, useEffect, useState } from 'react';
import { Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import TextInput from '../../../components/InputFields/TextInput';
import { useFormik } from 'formik';
import "./ApplicationType.css";
import { formikAddApplicationType } from '../Constant';
import { failed, success } from '../../../utils/Tostify';
import { updateApplicationType } from '../../../api/workflow';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../components/Loader/Loader';

const EditApplication = ({refetch, setShowModal,  appData, direction, ...args }) => {
    let token = useSelector(state => state.userReducer.token);
    const [dropdownOpenIndex, setDropdownOpenIndex] = useState(null); // Track which stage's dropdown is open
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();

    const formik = useFormik({
        ...formikAddApplicationType,
        onSubmit: async (values) => {
            let res;
            try {
                setIsLoading(true);
                res = await updateApplicationType({ values, dispatch, token, appId: appData?._id });
                if (res?.status == "SUCCESS") {
                    setShowModal();
                    setIsLoading(false);
                    success(res?.message);
                    await refetch();
                }else{
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                setIsLoading(false);
                failed(res?.message);
            }
        }
    });

    const handleAddStage = () => {
        const updatedStages = [
            ...formik.values.applicationStages,
            { name: '', child: [] }
        ];
        formik.setFieldValue('applicationStages', updatedStages);
    };

    const handleRemoveStage = (index) => {
        const updatedStages = formik.values.applicationStages.filter((_, i) => i !== index);
        formik.setFieldValue('applicationStages', updatedStages);
    };

    const handleStageChange = (index, value) => {
        const updatedStages = [...formik.values.applicationStages];
        updatedStages[index].name = value;
        formik.setFieldValue('applicationStages', updatedStages);
    };

    const handleAddChildStage = (index) => {
        const updatedStages = [...formik.values.applicationStages];
        updatedStages[index].child.push({ name: '' });
        formik.setFieldValue('applicationStages', updatedStages);
    };

    const handleRemoveChildStage = (stageIndex, childIndex) => {
        const updatedStages = [...formik.values.applicationStages];
        updatedStages[stageIndex].child = updatedStages[stageIndex].child.filter((_, i) => i !== childIndex);
        formik.setFieldValue('applicationStages', updatedStages);
    };

    const handleChildStageChange = (stageIndex, childIndex, value) => {
        const updatedStages = [...formik.values.applicationStages];
        updatedStages[stageIndex].child[childIndex].name = value;
        formik.setFieldValue('applicationStages', updatedStages);
    };

    const toggleDropdown = (index) => {
        setDropdownOpenIndex(dropdownOpenIndex === index ? null : index);
    };

    const setEditData =()=>{
        formik.setFieldValue("applicationTitle", appData?.applicationTitle);
        formik.setFieldValue("applicationStages", appData?.applicationStages);
    };

    useEffect(() => {
      setEditData();
    }, []);

  return (
    <Fragment>
      <Modal isOpen={setShowModal} toggle={()=>{setShowModal();}} size="xl" className='user_modal_block add_application_type'>
        <ModalHeader toggle={setShowModal} className="assign_blk">{appData.readOnly ? `View Application Type` : `Edit Application Type`}</ModalHeader>
        <Form onSubmit={formik.handleSubmit}>
        <ModalBody className="assign_modal_body">
        {isLoading ? <Loader /> : null}
            <div className="add_forms_workflow" style={{padding : "0px 15px 20px"}}>
                <div className="first_block mb-0">
                            <Row>
                                <Col xl={6} className="location_block">
                                    <TextInput
                                        keyField={"applicationTitle"}
                                        formik={formik}
                                        readOnly={appData.readOnly}
                                        label="Application Type Name"
                                        type="text"
                                        value={formik.values.applicationTitle}
                                        onChange={(e) => formik.setFieldValue("applicationTitle", e.target.value)}
                                    />
                                </Col>
                            </Row>
                            {formik.values.applicationStages.map((stage, stageIndex) => (
                                <div key={stageIndex}>
                                   <Row key={stageIndex}>
                                        <h6 className="stage_block">Stage {stageIndex + 1}</h6>
                                        <Col lg={6} className="location_block d-flex align-items-center gap-3">
                                            <TextInput
                                                keyField={`stage-${stageIndex}`}
                                                formik={formik}
                                                readOnly={appData.readOnly}
                                                label={`Parent Stage ${stageIndex + 1}`}
                                                type="text"
                                                value={stage.name}
                                                onChange={(e) => handleStageChange(stageIndex, e.target.value)}
                                            />
                                            {!appData.readOnly ? <Dropdown isOpen={dropdownOpenIndex === stageIndex} toggle={() => toggleDropdown(stageIndex)} direction={direction} className='dropdown_blk'>
                                                <DropdownToggle caret size="xl" className="column_blk">
                                                    <div className="for_details">
                                                        <i className="fa fa-ellipsis-v"></i>
                                                    </div>
                                                </DropdownToggle>
                                                <DropdownMenu {...args}>
                                                        <DropdownItem className="d-flex gap-2 drop_block_content align-items-center">
                                                            <div
                                                                className="add_hosp"
                                                                type="button"
                                                                onClick={() => handleAddChildStage(stageIndex)}
                                                            >
                                                                Add Child Stage
                                                            </div>
                                                        </DropdownItem>
                                                        {formik.values.applicationStages.length > 1 ? <DropdownItem className="d-flex gap-2 drop_block_content align-items-center">
                                                            <div
                                                                className="add_hosp"
                                                                type="button"
                                                                onClick={() => handleRemoveStage(stageIndex)}
                                                                disabled={formik.values.applicationStages.length === 1} // Disable delete button if only one stage left
                                                            >
                                                                Delete Stage
                                                            </div>
                                                        </DropdownItem> : null}
                                                </DropdownMenu>
                                            </Dropdown> : null}
                                        </Col>
                                        {stage.child.length > 0 && (
                                            <Col lg={6} className="location_block d-flex align-items-center gap-3 button_workflow">
                                                <TextInput
                                                    keyField={`childStage-${stageIndex}-0`}
                                                    formik={formik}
                                                    label="Child Stage 1"
                                                    readOnly={appData.readOnly}
                                                    type="text"
                                                    value={stage.child[0].name}
                                                    onChange={(e) => handleChildStageChange(stageIndex, 0, e.target.value)}
                                                />
                                                {!appData.readOnly ? <span
                                                    className="material-symbols-outlined"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => handleRemoveChildStage(stageIndex, 0)}
                                                >
                                                    delete
                                                </span> :  null}
                                            </Col>
                                        )}
                                    </Row>
                                    {stage.child.slice(1).map((childStage, childIndex) => (
                                        <Row key={`child-${stageIndex}-${childIndex + 1}`}>
                                            <Col lg={6}></Col>
                                            <Col lg={6} className="location_block d-flex align-items-center gap-3 button_workflow">
                                                <TextInput
                                                    keyField={`childStage-${stageIndex}-${childIndex + 1}`}
                                                    formik={formik}
                                                    readOnly={appData.readOnly}
                                                    label={`child Stage ${childIndex + 2}`}
                                                    type="text"
                                                    value={childStage.name}
                                                    onChange={(e) => handleChildStageChange(stageIndex, childIndex + 1, e.target.value)}
                                                />
                                                {/* <i className="fa fa-edit"></i> */}
                                                {!appData.readOnly ? <span className="material-symbols-outlined" style={{cursor : "pointer"}} onClick={() => handleRemoveChildStage(stageIndex, childIndex + 1)}> delete </span> : null}
                                            </Col>
                                        </Row>
                                    ))}
                                    </div>
                            ))}
                            <Row>
                                <div className="d-flex gap-5 justify-content-center button_workflow">
                                    {!appData.readOnly ? <button className="save_btn import" type="button" onClick={handleAddStage}> Add Stage</button> : null}
                                </div>
                            </Row>
                </div>
            </div>
        </ModalBody>
        <ModalFooter className="p-0 mt-3">
          {!appData.readOnly ? <div className="d-flex justify-content-center gap-5 mb-4">
            <button className="save_btn" onClick={setShowModal}>Close</button>
            <button className="save_btn second" type="submit">Save</button>
          </div> : null}
        </ModalFooter>
        </Form>
      </Modal>
    </Fragment>
  );
};

export default EditApplication;
